/*
 * File: /src/router/routes/leads.js
 * Created Date: Monday May 26th 2025
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Monday, 26th May 2025 2:13:17 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2025 AdBase, Inc.
 */
const LeadsDashboard = () =>
  import(
    /* webpackChunkName: "Leads" */ 'src/components/Dashboard/Views/Leads/LeadsDashboard.vue'
  );

export const leadsRoutes = [
  {
    path: 'leads/dashboard',
    name: 'Sales Dashboard',
    component: LeadsDashboard,
  },
];
